import { TFunction } from 'i18next';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function useCustomErrorMap() {
    const { t } = useTranslation();

    useEffect(() => {
        z.setErrorMap(makeErrorMap(t));
    }, [t]);
}

function makeErrorMap(t: TFunction): z.ZodErrorMap {
    return (issue, ctx) => {
        switch (issue.code) {
            case z.ZodIssueCode.too_small:
                return { message: t(`validations:too_small.${issue.type}`, { count: Number(issue.minimum) }) };
            case z.ZodIssueCode.invalid_string:
                return { message: t(`validations:invalid_string.${issue.validation}`) };
            case z.ZodIssueCode.invalid_enum_value:
                return { message: t(`validations:invalid_enum_value`) };
            case z.ZodIssueCode.invalid_type:
                return { message: t(`validations:invalid_type`) };
            case z.ZodIssueCode.custom:
                if (issue.params?.type) {
                    return { message: t(`validations:custom.${issue.params.type}`, { params: issue.params }) };
                }
                break;
        }

        // fall back to default message!
        return { message: ctx.defaultError };
    };
}
